import { render, staticRenderFns } from "./KbankCallback.vue?vue&type=template&id=28fc0eae&scoped=true"
import script from "./KbankCallback.vue?vue&type=script&lang=js"
export * from "./KbankCallback.vue?vue&type=script&lang=js"
import style0 from "./KbankCallback.vue?vue&type=style&index=0&id=28fc0eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc0eae",
  null
  
)

export default component.exports